"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchematicModelPortInstance = exports.SchematicModelPortNetEntryInstance = exports.SchematicModelPortSchema = exports.SchematicModelPortNetEntrySchema = void 0;
const zod_1 = require("zod");
const SignalDirection_1 = require("./SignalDirection");
const ProjectDataTypeInstance_1 = require("./ProjectInstances/ProjectDataTypeInstance");
exports.SchematicModelPortNetEntrySchema = zod_1.default.object({
    name: zod_1.default.string(),
    label: zod_1.default.string(),
});
exports.SchematicModelPortSchema = zod_1.default.object({
    name: zod_1.default.string(),
    nets: exports.SchematicModelPortNetEntrySchema.array(),
    direction: SignalDirection_1.SignalDirectionSchema.optional(),
});
class SchematicModelPortNetEntryInstance extends ProjectDataTypeInstance_1.ProjectDataTypeInstance {
    constructor(context, opts) {
        super(context);
        this.name = context.netRefCtx.existingOrNewRef(opts.name);
        this.label = opts.label;
    }
    toJSON() {
        return {
            name: this.name.valueOf(),
            label: this.label,
        };
    }
}
exports.SchematicModelPortNetEntryInstance = SchematicModelPortNetEntryInstance;
class SchematicModelPortInstance extends ProjectDataTypeInstance_1.ProjectDataTypeInstance {
    constructor(context, opts) {
        super(context);
        this.name = opts.name;
        this.nets = opts.nets.map((n) => new SchematicModelPortNetEntryInstance(context, n));
        this.direction = opts.direction;
    }
    toJSON() {
        return {
            name: this.name,
            nets: this.nets.map((n) => n.toJSON()),
            direction: this.direction,
        };
    }
}
exports.SchematicModelPortInstance = SchematicModelPortInstance;
//# sourceMappingURL=SchematicModelPort.js.map